import GlobalCampaignSidebar from '../GlobalCampaignSidebar'
import { useCampaignSidebar } from '../../contexts/CampaignSidebarContext/useCampaignSidebar'
import styles from './styles.module.css'

const GlobalSidebar = () => {
  const { isVisible, isExpanded } = useCampaignSidebar()

  if (!isVisible) {
    return null
  }

  return (
    <div
      className={`${styles.shell}${isExpanded ? '' : ` ${styles.shellCollapsed}`}`}
    >
      <GlobalCampaignSidebar />
    </div>
  )
}

export default GlobalSidebar
